import { InjectionToken } from '@angular/core';

export interface Hosts {
  crms: string;
  individualAuth: string;
  individualProfile: string;
}
export const HOSTS = new InjectionToken<Hosts>('BACKEND_HOSTS');
